import { responseMiddleware } from "services/alert";
import { request } from "services/request";

const resource = "api/home";

const errorReq = () => {
    return fetch(`/${resource}/error`, {
        method: "GET",
        headers: { "X-Device-Id": localStorage.getItem("deviceId") ?? "" },
    })
        .then((res) => responseMiddleware(res, {}))
        .catch((err) => console.error({ type: "error", message: "Неудачный запрос", title: "Ошибка.", err }));
};

const ip = () => request(`${resource}/ip`, { method: "GET" });

const headers = () => request(`${resource}/headers`, { method: "GET" });

const ping = () => request(`${resource}/ping`, { method: "GET" });

export { errorReq, ip, headers, ping };
